<script setup>
  import { ref, watch, onMounted } from 'vue'
  const prorps = defineProps(['modelValue'])
  const emit = defineEmits(['update:modelValue'])
  const _color = ref(prorps.modelValue)
  watch(
    () => prorps.modelValue,
    newVal => {
      _color.value = newVal
    }
  )
  watch(_color, newVal => {
    emit('update:modelValue', newVal)
  })
  const colorList = ['r0', 'y0', 'g0', 'b0', 'r1', 'y1', 'g1', 'b1', 'r2', 'y2', 'g2', 'b2']

  const classColor = {}
  const styles = getComputedStyle(document.documentElement)
  colorList.forEach(color => {
    classColor[color] = styles.getPropertyValue(`--${color}-bg`)
  })

  //スタイルの変数を取得

  const open = ref(false)
  const bookmark = ref(null)
  const select = ref(null)

  onMounted(() => {
    window.addEventListener('click', e => {
      if (e.target === bookmark.value) {
        open.value = !open.value
      } else if (e.target !== select.value) {
        open.value = false
      }
    })
  })
</script>

<template>
  <span class="bookmark-input">
    <div class="bookmark" ref="bookmark">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
        <path :fill="classColor[_color] || '#eeeeee'" d="M 37 48 C 36.824219 48 36.652344 47.953125 36.496094 47.863281 L 25 41.15625 L 13.503906 47.863281 C 13.195313 48.042969 12.8125 48.046875 12.503906 47.867188 C 12.191406 47.6875 12 47.359375 12 47 L 12 3 C 12 2.449219 12.449219 2 13 2 L 37 2 C 37.554688 2 38 2.449219 38 3 L 38 47 C 38 47.359375 37.808594 47.6875 37.496094 47.867188 C 37.34375 47.957031 37.171875 48 37 48 Z" />
      </svg>
    </div>
    <span class="color-select" v-if="open">
      <div class="color" @click="_color = ''" style="background-color: #eeeeee"></div>
      <div class="colors" ref="select">
        <div class="color" v-for="color in colorList" :key="color" @click="_color = color" :class="color"></div>
      </div>
    </span>
  </span>
</template>
